import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {KeycloakWrapperService} from '../keycloak/keycloak-wrapper.service';
import {inject} from '@angular/core';


export const includeFnpBearerTokenInterceptor: (req: HttpRequest<unknown>, next: HttpHandlerFn) => Observable<HttpEvent<unknown>>
    = (req, next) => {
    const _kcService: KeycloakWrapperService = inject(KeycloakWrapperService);
    const token = _kcService.token;
    return next((token) ?
        req.clone({
            setHeaders: {'Authorization': `Bearer ${_kcService.token}`}
        })
        : req);
};

